import "./Home.module.css";
import MainHeader from "@/reusable_sections/Header";
import ManifestYourVision from "./sections/ManifestYourVision";
import TheCostOfSilence from "./sections/TheCostOfSilence";
import TheMollyCallSolution from "./sections/TheMollyCallSolution";
import PlatformCapabilities from "./sections/PlatformCapabilities";
import ModularAiAgents from "./sections/ModularAiAgents";
import IntelligenceLayer from "./sections/IntelligenceLayer";
import SectorApplications from "./sections/SectorApplications";
import BusinessOutcomes from "./sections/BusinessOutcomes";
import ReadyForABetterHr from "./sections/ReadyForABetterHr";
import DemoScheduler from "./sections/DemoScheduler";
import Footer from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <MainHeader />
      <ManifestYourVision />
      <TheCostOfSilence />
      <TheMollyCallSolution />
      <PlatformCapabilities />
      <ModularAiAgents />
      <IntelligenceLayer />
      <SectorApplications />
      <BusinessOutcomes />
      <ReadyForABetterHr />
      <DemoScheduler />
      <Footer />
    </div>;
}